import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import videoSrc from '../videos/main_header_video.mp4';
import { FaPlay } from 'react-icons/fa';
import '../pages/home/home.css';
 
const MainHeader = () => {
    const [showVideo, setShowVideo] = useState(false);
    const [setIsHovering] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const { user } = useAuth(); // Access user from AuthContext

    // Load animation only after component mounts
    useEffect(() => {
        setIsLoaded(true);
        return () => setIsLoaded(false);
    }, []);

    const handleVideoClick = () => {
        setShowVideo(true);
        // Track this event in analytics
        if (window.gtag) {
            window.gtag('event', 'video_play', {
                'event_category': 'engagement',
                'event_label': 'Main Header Video'
            });
        }
    };

    return (
        <header className="main__header" aria-label="Main header with video demo">
            <div className="main-header-container">
                {/* Left Box */}
                <div className="main__header-left main__header-box">
                    <h4 className="main__header-title">Video interview platform</h4>
                    <h1 className="main__header-subtitle">
                        Let's make a powerful change to your recruiting process
                    </h1>
                    <p className="main__header-text">
                        Simplify your hiring and recruiting process with Layer 3.
                    </p> 
                    <div className="buttons-container">
                        <Link to="/makerequest" className="btn demo-btn">Candidate Request</Link>
                        {/* Conditionally render the Sign In button */}
                        {!user && ( // Only show if user is NOT logged in
                            <Link to="/login" className="btn signin-btn">Sign In</Link>
                        )}
                    </div>
                </div>

                {/* Video Section */}
                <div className={`main__header-video ${isLoaded ? 'loaded' : ''}`}>
                    {showVideo ? (
                        <video
                            src={videoSrc}
                            controls
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="main__video"
                            aria-label="Product demonstration video"
                            title="Layer 3 Product Demo"
                        >
                            Your browser does not support HTML5 video. 
                            <a href={videoSrc} download>Download the video</a> instead.
                        </video>
                    ) : (
                        <button 
                            className="video-placeholder"
                            onClick={handleVideoClick}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                            aria-label="Play product demonstration video"
                        >
                            <div className="video-thumbnail-overlay">
                                <div className="video-play-icon-container">
                                    <div className="video-play-icon" aria-hidden="true">
                                        <FaPlay />
                                    </div>
                                    <div className="video-play-circle video-play-circle-1" aria-hidden="true"></div>
                                    <div className="video-play-circle video-play-circle-2" aria-hidden="true"></div>
                                </div>
                                <span className="video-play-text">Watch Demo Video</span>
                            </div>
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

export default React.memo(MainHeader);